export const URLSearchCategoryIndicator = "category_";
export const convertToURLObj = (mapPosition, selectedFilters) => {
    let urlParamsObj = {};
    if (mapPosition) {
        urlParamsObj = {
            lat: mapPosition.lat,
            lng: mapPosition.lng,
            zoom: mapPosition.zoom,
        };
    }
    if (selectedFilters) {
        const filterObj = {};
        for (const filter in selectedFilters) {
            const [categoryKey, filterKey] = filter.split(".");
            if (filterObj[categoryKey]) {
                filterObj[categoryKey] = [...filterObj[categoryKey], filterKey];
            }
            else {
                filterObj[categoryKey] = [filterKey];
            }
        }
        for (const categoryKey in filterObj) {
            urlParamsObj[`${URLSearchCategoryIndicator}${categoryKey}`] = filterObj[categoryKey];
        }
    }
    return urlParamsObj;
};
export const convertFromURLParams = (urlParams) => {
    const mapPosition = {};
    if (urlParams.has("lat")) {
        mapPosition["lat"] = parseFloat(urlParams.get("lat"));
    }
    if (urlParams.has("lng")) {
        mapPosition["lng"] = parseFloat(urlParams.get("lng"));
    }
    if (urlParams.has("zoom")) {
        mapPosition["zoom"] = parseFloat(urlParams.get("zoom"));
    }
    const selectedFilters = {};
    const searchKeys = urlParams.keys();
    for (const searchKey of searchKeys) {
        if (!searchKey.includes(URLSearchCategoryIndicator))
            continue;
        const categoryKey = searchKey.replace(URLSearchCategoryIndicator, "");
        const filterKeys = urlParams.get(searchKey).split(",");
        filterKeys.forEach((filterKey) => {
            selectedFilters[`${categoryKey}.${filterKey}`] = {
                key: filterKey,
                selected: true,
                category: categoryKey,
            };
        });
    }
    return { mapPosition, selectedFilters };
};
export const getInitialDataFromURL = (isFiltersSharingEnabled) => {
    if (isFiltersSharingEnabled && window) {
        const urlParams = new URLSearchParams(window.location.search);
        return convertFromURLParams(urlParams);
    }
    return { selectedFilters: {}, mapPosition: {} };
};
//# sourceMappingURL=convertSharedFilterData.js.map